import { IconWrapper } from '../runtime';
export default IconWrapper('add-right', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M11.75 5.49976V10.4998M14.25 7.99976H9.25M1.75 3.49976C1.75 2.67133 2.42157 1.99976 3.25 1.99976H4.75C5.57843 1.99976 6.25 2.67133 6.25 3.49976V12.4998C6.25 13.3282 5.57843 13.9998 4.75 13.9998H3.25C2.42157 13.9998 1.75 13.3282 1.75 12.4998V3.49976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});